// src/components/MainReg.js
import React from 'react';
import MembershipForm from './MembershipForm';
import PublicLayout from '../components/public/PublicLayout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MainReg = () => {
  // Empty user object - no pre-filled data
  const user = {
    firstName: '',
    lastName: '',
    email: '',
  };

  // Dummy sign-out function for demonstration
  const handleSignOut = () => {
    alert('Signing out...');
  };

  // Get the current year for the copyright notice
  const currentYear = new Date().getFullYear();

  return (
    <PublicLayout>
      <div className="bg-light py-4">
        <MembershipForm user={user} onSignOut={handleSignOut} />
      </div>
      
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </PublicLayout>
  );
};

export default MainReg;